export default __webpack_public_path__ + "static/media/Baboon.b3217cec.jpg";